// Mock data for Digi Loans

export const contactInfo = {
  phone: '+91 9703850009',
  email: 'prasad@digiloansbazaar.com',
  address: 'Plot No. 108, Door No. 1-11, 256/B, Street No. 1, Bhagwathapur, Begumpet, Hyderabad, Telangana – 500016',
  businessHours: 'Monday – Saturday: 9:00 AM – 7:00 PM',
  mapUrl: 'https://maps.google.com/maps?q=Bhagwathapur,Begumpet,Hyderabad,Telangana+500016&t=&z=15&ie=UTF8&iwloc=&output=embed'
};

export const founderInfo = {
  name: 'D.N.V. Prasad',
  title: 'Founder & Owner',
  phone: '9703850009',
  description: 'With extensive experience in financial consulting and loan facilitation, D.N.V. Prasad is committed to helping businesses and healthcare institutions secure funding for sustainable growth.',
  photoUrl: 'https://customer-assets.emergentagent.com/job_hospital-loan-hub/artifacts/j7ag28as_Screenshot_20260602_083633_ChatGPT.jpg'
};

export const services = [
  {
    id: 1,
    icon: 'Building2',
    title: 'Hospital Project Financing',
    description: 'Complete financing for medical equipment, hospital infrastructure, OT & ICU setup, furniture & interiors, HVAC & power backup.',
    features: ['Medical Equipment', 'Hospital Infrastructure', 'OT & ICU Setup', 'Furniture & Interiors', 'HVAC & Power Backup'],
    image: 'https://customer-assets.emergentagent.com/job_hospital-loan-hub/artifacts/vcy5758c_Screenshot_20260602_101306_ChatGPT.jpg'
  },
  {
    id: 2,
    icon: 'Briefcase',
    title: 'Business Loans',
    description: 'Customized funding solutions for business expansion, startups, MSMEs, and term loans.',
    features: ['Expansion Funding', 'Startup Loans', 'MSME Loans', 'Term Loans'],
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f'
  },
  {
    id: 3,
    icon: 'Stethoscope',
    title: 'Doctor Loans',
    description: 'Special funding solutions for doctors, clinics, diagnostic centers, and nursing homes.',
    features: ['Doctors', 'Clinics', 'Diagnostic Centers', 'Nursing Homes'],
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56'
  },
  {
    id: 4,
    icon: 'Activity',
    title: 'Medical Equipment Finance',
    description: 'Finance for MRI, CT Scan, Ultrasound, X-Ray systems, and lab equipment.',
    features: ['MRI', 'CT Scan', 'Ultrasound', 'X-Ray Systems', 'Lab Equipment'],
    image: 'https://customer-assets.emergentagent.com/job_hospital-loan-hub/artifacts/wahwzh3x_Screenshot_20260602_102423_ChatGPT.jpg'
  },
  {
    id: 5,
    icon: 'TrendingUp',
    title: 'Working Capital & OD',
    description: 'Cash credit, overdraft facilities, working capital loans, and business growth funding.',
    features: ['Cash Credit', 'Overdraft Facilities', 'Working Capital Loans', 'Business Growth Funding'],
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40'
  }
];

export const whyChooseUs = [
  { icon: 'Award', title: 'Experienced Financial Experts', description: 'Years of expertise in loan facilitation' },
  { icon: 'Settings', title: 'Customized Funding Solutions', description: 'Tailored to your specific needs' },
  { icon: 'Handshake', title: 'Strong Banking Partnerships', description: 'Tie-ups with leading banks' },
  { icon: 'Zap', title: 'Quick Documentation Support', description: 'Fast processing and approvals' },
  { icon: 'Shield', title: 'Transparent Process', description: 'No hidden charges or surprises' },
  { icon: 'Users', title: 'End-to-End Assistance', description: 'Complete support from start to finish' }
];

export const heroFeatures = [
  'Start-up Hospital Funding Up to ₹10Cr',
  'Medical Equipment Loans and Refinance',
  'Up to 100% Project Financing',
  'No Collateral Required*',
  'Fast Processing & Approvals',
  'Expert Financial Guidance'
];
